import type { FinancialInputMeta } from "../../lib/onboarding-types";

/**
 * The four canonical money categories the chip's dot row summarizes — the
 * same `field` strings `lib/finance/finance-inputs.ts` keys its per-category
 * groups on (household income, cash-to-close savings, monthly debts, credit
 * band). Plan 435 M2 (mfh-hero-readiness-chip).
 */
export const READINESS_CHIP_DOT_FIELDS = [
  "household_income",
  "savings",
  "monthly_debts",
  "credit_score",
] as const;

export function computeReadinessChipDots(
  financialInputs: readonly FinancialInputMeta[] | undefined,
): boolean[] {
  const inputs = financialInputs ?? [];
  return READINESS_CHIP_DOT_FIELDS.map((field) =>
    inputs.some((input) => input.field === field && input.present),
  );
}
